import { useEffect } from "react";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";
import { Clock } from "lucide-react";

/**
 * Toasts a warning when the auth idle warning flag flips on
 * (see IDLE_TIMEOUT_MS in auth.jsx — 20 min total, warning at last 1 min).
 */
export function SessionIdleWarning() {
  const { idleWarning, user } = useAuth();
  useEffect(() => {
    if (idleWarning && user) {
      toast.warning("You'll be signed out soon due to inactivity.", {
        icon: <Clock className="h-4 w-4" />,
        duration: 8000,
        id: "aura-idle-warning",
      });
    }
  }, [idleWarning, user]);
  return null;
}
